import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { actionTypes, useStateValue } from "./../../store";
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header';
import { compareProducts } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';

const Compare = () => {


    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [{ compareitemcount }, dispatch] = useStateValue();

    // const removeAllCompareData = () => {
    //     localStorage.removeItem("allEntries");
    //     dispatch({ type: actionTypes.SET_COMPAREITEMCOUNT, value: '' });

    // }
    const goBack = () => {
        navigate(-1);
    }
    const [resultData, setResultData] = React.useState([]);
    const callCompareData = (value) => {
        var data = new FormData();
        data.append('productsIds', value);
        setLoading(true);
        compareProducts(data).then((res) => {
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setResultData(res.data.ProductList);
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    return true;
                case 0:
                    //setResultData(res.data.ProductList);
                    dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
                    dispatch({ type: actionTypes.SET_MSGALERTDATA, value: res.data.msz });
                    dispatch({ type: actionTypes.SET_MSGALERT, value: true });
                    break;
                default:
                    return;
            }
        })
    };

    useEffect(() => {
        callCompareData(location.state.id)
    }, [location.state.id]);


    return (
        <>
            <Header />
            {loading ? <><LoadingCellFullPage /></> : <>
                {resultData && resultData?.length > 0?<>
                    <div className='innerpagebg pt-5 pb-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <h3 className='txtdgray text-uppercase fw-bold f22'>Compare</h3>
                            </div>
                        </div>
                    </div>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className="compare card">
                                    <div className='d-flex align-items-center p-3 justify-content-between' style={{ backgroundColor: '#f7f7f7' }}>
                                        <div className='f16 text-uppercase fw-bold'>
                                            <span className='txtred'>Compare</span> <span className='txtdgray'>Result</span>
                                        </div>
                                        {/* <Button variant="text" 
                                    onClick={removeAllCompareData} 
                                    size="small" className='d-block'>
                                         REMOVE ALL
                                    </Button> */}
                                        <Button variant="text"
                                            onClick={goBack}
                                            size="small" className='d-block'>
                                            GO BACK
                                        </Button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="compare__table compare-table table">
                                            <thead className="thead-default">
                                                <tr className='compare-table__row'>
                                                    <th />
                                                    {resultData && resultData?.map(product =>
                                                        <th key={product?.productId} className="compare-table__column--product">
                                                            <Link to={`/product-detail/${product?.slug}`}><img alt="" className="img-fulid" style={{ maxWidth: '100px' }} src={product?.image} /></Link>
                                                            <Link to={`/product-detail/${product?.slug}`}><p className='mt-3 text-black'>{product?.name}</p></Link>
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="price">
                                                    <th scope="row" className='compare-table__column compare-table__column--header' style={{ width: '200px' }}>Price</th>
                                                    {resultData && resultData?.map(product =>
                                                        <td key={product.productId} className="compare-table__column--product" >
                                                            
                                                            {product?.price > '0.00' ? <>{product?.price}</>:<>-</>}
                                                        </td>
                                                    )}
                                                </tr>
                                                <tr className="category">
                                                    <th scope="row" className='compare-table__column compare-table__column--header'>Category</th>
                                                    {resultData && resultData?.map(product =>
                                                        <td key={product.productId} className="compare-table__column--product">
                                                            {product?.catLabel}
                                                        </td>
                                                    )}
                                                </tr>
                                                <tr className='spectd'>
                                                    <th scope="row" className='compare-table__column compare-table__column--header'>Product Specifications</th>
                                                    {resultData && resultData.slice(0, 1).map(product =>
                                                        <>{product?.productSpecifications.slice(0, 1)?.map(item =>
                                                            <>
                                                                {resultData && resultData?.map(product =>
                                                                    <td key={product.productId} className="compare-table__column--product text-start" style={{ padding: '0px' }} >
                                                                        {product?.productSpecifications?.map(itemin =>
                                                                            <div className=''>
                                                                                <div className='bglblue fw-bold p-2'><span className='dp-sptable'>{itemin?.label}</span> &nbsp;</div>
                                                                                {itemin?.list?.map((ites, i) =>
                                                                                    <div key={ites?.id}className='p-2  justify-content-between valuedetal border-bottom'>
                                                                                        <div className='f12 fw-bold lblkeywrap'><span className='lblkey'>{ites?.label}</span>&nbsp;</div>
                                                                                        <div className='f12 lblvalue'>{ites?.value?<>{ites?.value}</>:<>-</>}</div>
                                                                                    </div>
                                                                                )}
                                                                                <hr className='m-0' />
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                )}
                                                            </>
                                                        )}</>
                                                    )}
                                                </tr>
                                                <tr className="category">
                                                    <th scope="row" className='compare-table__column compare-table__column--header'></th>
                                                    {resultData && resultData?.map(product =>
                                                        <th key={product?.productId} className="compare-table__column--product">
                                                            <Link to={`/product-detail/${product?.slug}`} className="btn btn-warning btm-sm f12">View Product</Link>
                                                        </th>
                                                    )}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </>:<>
                <div className='row'>
                                <div className='col-lg-12'>
                                    <div className='card text-center p-4'>
                                        No Records Found
                                    </div>
                                </div>
                            </div>
                </>}
              
                </>}
            <FotterMain />
        </>
    )
}

export default Compare